import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=490484f3&scoped=true&"
import script from "./Autocomplete.vue?vue&type=script&lang=ts&"
export * from "./Autocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490484f3",
  null
  
)

export default component.exports